import { CheckIcon, ClipboardDocumentIcon } from '@heroicons/react/24/outline'
import { motion } from 'framer-motion'
import PropTypes from 'prop-types'

import { classNames } from '../../helpers'
import { SPRING, VARIANTS } from './tokens'

const { initial: hidden, animate: shown } = VARIANTS.scaleIn

// Kopier-Icon, das nach dem Kopieren per Scale zum Haken wechselt. Größe und
// Farbe kommen über className, die Hakenfarbe über checkClassName.
const AnimatedCopyIcon = ({
  copied,
  icon: Icon,
  className,
  checkClassName
}) => (
  <span
    aria-hidden='true'
    className={classNames('relative inline-flex shrink-0', className)}
  >
    <motion.span
      className='absolute inset-0'
      initial={false}
      animate={copied ? hidden : shown}
      transition={SPRING.snappy}
    >
      <Icon className='size-full' />
    </motion.span>
    <motion.span
      className={classNames('absolute inset-0', checkClassName)}
      initial={false}
      animate={copied ? shown : hidden}
      transition={SPRING.snappy}
    >
      <CheckIcon className='size-full' />
    </motion.span>
  </span>
)

AnimatedCopyIcon.propTypes = {
  copied: PropTypes.bool.isRequired,
  icon: PropTypes.elementType,
  className: PropTypes.string,
  checkClassName: PropTypes.string
}

AnimatedCopyIcon.defaultProps = {
  icon: ClipboardDocumentIcon,
  className: 'size-4',
  checkClassName: 'text-green-600'
}

export default AnimatedCopyIcon
